// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"77cd015f","302":"55fdbacf","453":"7bef9472","667":"3904285d"}[chunkId] + ".chunk.js";
};